import classic from "./classic.png";
import soon from "./soon.png";
import video from "./video.png";

export { classic, soon, video };
